// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"c9f40f0e","951":"adc8dcb4"}[chunkId] + ".chunk.css";
};